import PATH from "constants/path";

const LIST_MENU = [
  {
    path: PATH.TOP,
    name: "TOP",
  },
  {
    path: PATH.FIRST,
    name: "はじめての方へ",
  },
  {
    path: PATH.GUIDE,
    name: "ご利用方法",
  },
  {
    path: PATH.POINT,
    name: "ポイントについて",
  },
  {
    path: PATH.NEWS,
    name: "お知らせ",
  },
  {
    path: PATH.AREA_LIST,
    name: "モニター説明会場",
  },
  {
    path: PATH.QUESTIONS,
    name: "よくあるご質問",
  },
  {
    path: PATH.CONTACT,
    name: "お問い合わせ",
  },
];

export { LIST_MENU };
